import React from 'react'
import { Grid, Header } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import CountUp from 'react-countup';
class TwoBlockDivisionWithHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    goToContent(e, pageType, pageName) {
        dispatch.home.redirectFromEventStream(true)
        const history = this.props.history;
        let urlPath = ""
        setTimeout(
            function () {
                if (pageType === 'content') {
                    dispatch.content.setContentList([]);
                    let statusQuery = {}
                    if (pageName === 'Sent') {
                        statusQuery.author = this.props.user._id;
                        statusQuery.status = 'under_review';
                        statusQuery.dataStatus = 'reviewRequestContent'
                        statusQuery.organizationId = this.props.selectedOrganisation.id;
                        dispatch.content.getUnderReviewContents(statusQuery);
                        dispatch.content.setTreeCurrentPath("0/2/1")
                        history.push({
                            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_ct/status/reviewRequest'
                        });
                    } else if (pageName === 'Received') {
                        statusQuery.status = 'under_review';
                        statusQuery.dataStatus = 'forreviewContent'
                        statusQuery.organizationId = this.props.selectedOrganisation.id;
                        statusQuery.reviewedby = this.props.user._id;
                        dispatch.content.getUnderReviewContents(statusQuery);
                        dispatch.content.setTreeCurrentPath("0/2/1")
                        history.push({
                            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_ct/status/forreview'
                        });
                    }


                }
                else if (pageType === 'playbook') {
                    // below changes added for KLM-8993
                    if (pageName === 'Sent') {
                        urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/inReview'
                        dispatch.lifeCycle.setTreeCurrentPath("0/1/1")
                    } else if (pageName === 'Received') {
                        urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/forReview'
                        dispatch.lifeCycle.setTreeCurrentPath("0/1/0")
                    }

                    history.push({
                        pathname: urlPath
                    });
                }
            }.bind(this), 200);
    }
    render() {
        return (
            <Grid className="mar_0" className="count-block-item setHoverEffect" >
                <Grid.Row style={{ padding: "10px 0 0 0" }}>
                    <Header as='h6' textAlign='center' className="w_100" >
                        <Header.Content>{this.props.header}</Header.Content>
                    </Header>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={8} style={{ padding: "5px 0 " }} onClick={(e) => this.goToContent(e, this.props.type, this.props.label1Name)}>
                        <div>
                            <CountUp end={this.props.label1Count} duration={5} />
                        </div>
                        <label>{this.props.label1Name}</label>
                    </Grid.Column>
                    <Grid.Column width={8} style={{ padding: "5px 0 " }} onClick={(e) => this.goToContent(e, this.props.type, this.props.label2Name)}>
                        <div>
                            <CountUp end={this.props.label2Count} duration={5} />
                        </div>
                        <label>{this.props.label2Name}</label>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }
}

export default withRouter(TwoBlockDivisionWithHeader);